import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@/components/ui/skeleton';
export const HeroSkeletonMd = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Skeleton className="h-[clamp(220px,25vw,400px)] w-full rounded-none" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const BreadcrumbSkeleton = t0 => {
  const $ = _c(4);
  const {
    items: t1
  } = t0;
  const items = t1 === undefined ? 1 : t1;
  let t2;
  let t3;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <Skeleton className="h-3 w-3 rounded-sm" />;
    t3 = <Skeleton className="hidden h-3 w-12 sm:block" />;
    $[0] = t2;
    $[1] = t3;
  } else {
    t2 = $[0];
    t3 = $[1];
  }
  let t4;
  if ($[2] !== items) {
    t4 = <div className="border-b border-gray-200 bg-white shadow-sm dark:border-gray-700 dark:bg-gray-900"><div className="px-4 py-3 sm:px-6 lg:px-8"><div className="flex items-center gap-2">{t2}{t3}{Array.from({
            length: items
          }).map(_temp)}</div></div></div>;
    $[2] = items;
    $[3] = t4;
  } else {
    t4 = $[3];
  }
  return t4;
};
export const UserNavigationSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex w-full flex-row gap-1 rounded-lg bg-gray-100 p-1">{Array.from({
        length: 4
      }).map(_temp2)}</div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export const SidebarSkeleton = () => {
  const $ = _c(2);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="border-b border-gray-200 bg-gray-50 px-6 py-4"><Skeleton className="h-6 w-32" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <aside className="w-full lg:w-72 lg:shrink-0"><div className="rounded-md border border-gray-200 bg-white shadow-xs">{t0}<nav className="p-2"><ul className="space-y-1">{Array.from({
              length: 7
            }).map(_temp3)}</ul></nav></div></aside>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  return t1;
};
export const ArticleBodySkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="space-y-4"><Skeleton className="h-5 w-full" /><Skeleton className="h-5 w-11/12" /><Skeleton className="h-5 w-4/5" /><Skeleton className="h-5 w-full" /><Skeleton className="h-5 w-3/4" /><div className="py-2" /><Skeleton className="h-5 w-full" /><Skeleton className="h-5 w-5/6" /><Skeleton className="h-5 w-full" /><Skeleton className="h-5 w-2/3" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
function _temp(_, i) {
  return <span key={i} className="flex items-center gap-2"><Skeleton className="h-4 w-4 rounded-sm" /><Skeleton className="h-3 w-20" /></span>;
}
function _temp2(_, i) {
  return <div key={i} className="flex-auto"><Skeleton className="h-10 w-full rounded-md" /></div>;
}
function _temp3(_, i) {
  return <li key={i} className="flex items-center justify-between rounded-md px-4 py-3"><Skeleton className="h-4 w-32" /><Skeleton className="h-4 w-4 rounded-sm" /></li>;
}